<template>
  <div class="containerCS">
    <p class="inputLabelCS">
      Submit your details to view your estimated savings and personalized design.
    </p>
    <div class="rupee">
                    <el-input
                      v-model="billAmount"
                      placeholder="Enter Average Monthly Bill *"
                      type="number"
                    >
                    <template v-slot:prefix>
                        <b-icon style="color:black" :icon="true?'currency-rupee' :'currency-dollar'"></b-icon>
                    </template>
                    </el-input>
      <p class="billError" v-if="isRil && Number.isInteger(parseFloat(billAmount)) && (parseFloat(billAmount)<100)">
        {{'Value should be equal or more than 100'}}
      </p>
      <p class="billError" v-if="!isRil && Number.isInteger(parseFloat(billAmount)) && (parseFloat(billAmount)<1000)">
        {{'Value should be equal or more than 1000'}}
      </p>
    </div>
                    <el-input
                      v-model="name"
                      placeholder="Enter Your Name *"
                      type="text"
                    />
                    <el-input    
                      v-model="mobileNum"
                      placeholder="Enter Your Mobile No. *"
                      type="number"
                    />
    <p class="billError" v-if="mobileNum && (mobileNum>9999999999||mobileNum.toString().length!==10)">
      {{'Value should have 10 digits'}}
    </p>
                    <el-input    
                      v-model="emailId"
                      placeholder="Enter Your Email Id *"
                      type="text"
                    />
  <p class="billError" v-if="emailId && !isValidEmail">
      {{'Please enter a valid email address'}}
    </p>                    <el-input    
                      v-model="address"
                      placeholder="Enter Your Address *"
                      type="text"
                    />
    <el-button 
      type="primary" 
      class="BtnMDCS"
      :disabled="!isSavingsFormValid"
      @click="submitSavingsFunction"
      >Submit & Calculate Savings</el-button
    >
  </div>
</template>

<script>
import { useStudioStore } from "../store/studioStore";
import {SAVINGS_STATE, REPORT_STATE, defaultComponentsData} from "./constants";
import { isRil } from "../../constants";
import API from '@/services/api';
import { uploadFileToBlob } from "@/utils.js";
import { v4 } from "uuid";

export default {
  data() {
    return {
      name: null,
      billAmount: null,
      mobileNum: null,
      emailId: null,
      leadId: null,
      leadAlreadyExistsInDB: false,
      studioStore: useStudioStore(),
      canvasImage: null,
      imageUUID: null,
      address: null,
      isRil,
    }
  },
  mounted() {
    let componentData = localStorage.getItem('componentData');
    if(componentData){
      componentData = JSON.parse(componentData);
      this.name = componentData.savingsData.name;
      this.billAmount = componentData.savingsData.billAmount;
      this.mobileNum = componentData.savingsData.mobileNum;
      this.emailId = componentData.savingsData.emailId;
      this.leadId = componentData.savingsData.leadId;
      this.address = componentData.savingsData.address;
      this.leadAlreadyExistsInDB = componentData.savingsData.leadAlreadyExistsInDB;
    }
    // this.$stageInstance.placePanels();
  },
  computed: {
    currentAppState() {
      return this.studioStore.currentAppState;
    },
    isValidEmail() {
      console.log('sadjasld');
      return /^[^@]+@\w+(\.\w+)+\w$/.test(this.emailId);
    },
    validBillAmount(){
      return this.isRil ? this.billAmount > 99 : this.billAmount > 999
    },
    isSavingsFormValid() {
      if(this.name && this.address 
      && this.billAmount && this.validBillAmount 
      && this.mobileNum && this.mobileNum > 999999999 && this.mobileNum <= 9999999999  
      && this.emailId && this.isValidEmail){
        return true;
      }
      return false;
    },
  },
  methods: {
     preventInvalidInput(event) {
    const inputValue = event.target.value;
    // Prevent non-numeric or invalid characters
    if (!/^\d*$/.test(inputValue)) {
      event.target.value = inputValue.replace(/\D/g, '');
    }
    this.billAmount = parseInt(event.target.value) || null;
  },
    uploadFileToBlob,
    cleanBase64String(base64String) {
      // Define a regular expression to match valid base64 characters
      const base64Regex = /^[A-Za-z0-9+/=]+$/;
      // Use the regular expression to filter out invalid characters
      const cleanString = base64String.replace(new RegExp(`[^${base64Regex.source}]`, 'g'), '');
      return cleanString;
    },
    async submitSavingsFunction() {
      if(this.currentAppState === SAVINGS_STATE){
        //upload the image for rel
        if (localStorage.getItem('canvasImage')) {
          this.canvasImage = localStorage.getItem('canvasImage');
        } else {
          this.canvasImage = "https://cdn.pixabay.com/photo/2012/08/27/14/19/mountains-55067__340.png";
        }
        if (this.$stageInstance) {
          const uuidImage =  v4();
          this.imageUUID = uuidImage;
          //remove prefix
          const base64WithoutPrefix = this.canvasImage.split(',')[1];
          //check and remove invalid characters
          const cleanedBase64 = this.cleanBase64String(base64WithoutPrefix);
          const binaryData = Uint8Array.from(
            atob(cleanedBase64),
            (char) => char.charCodeAt(0)
          );
          // Create a Blob object from binary data
          const binaryImage =new Blob([binaryData], { type: "image/png" });
          await this.uploadFileToBlob(binaryImage,uuidImage);
        }
        this.studioStore.$patch({
          currentAppState: REPORT_STATE,
        });
        const postData = {
          "name": this.name,
          "phone": parseFloat(this.mobileNum),
          "email": this.emailId,
          "source": isRil ? "sensehawk" : "tata_power",
          "monthly_bill": parseFloat(this.billAmount),
          "address": this.address,
        }
        // Conditionally add the "map_image" property if this.imageUUID exists
        if (this.imageUUID!==null) {
          postData.map_image = {
            "file_name": this.imageUUID,
            "file_info": "map_image",
            "file_type": "image",
          };
        }
        if(!this.leadAlreadyExistsInDB){
          try{
            const response = await API.STUDIO_API.CREATE_LEAD(postData);
            if(response.data.hasOwnProperty('id')){
              this.leadId = response.data.id;
            }
            this.leadAlreadyExistsInDB = true;
          }
          catch(e){
            console.error(e);
          }
        }
        else if(this.leadId){
          const postData = {};
          let componentData = JSON.parse(localStorage.getItem('componentData'));
          if(this.name !== componentData.savingsData.name){
            postData.name = this.name;
          }
          if(this.mobileNum !== componentData.savingsData.mobileNum){
            postData.phone = this.mobileNum;
          }
          if(this.emailId !== componentData.savingsData.emailId){
            postData.email = this.emailId;
          }
          if(this.billAmount !== componentData.savingsData.billAmount){
            postData.monthly_bill = this.billAmount;
          }
          if(this.address !== componentData.savingsData.address){
            postData.address = this.address;
          }
          try{
            await API.STUDIO_API.PATCH_LEAD(this.leadId, postData);
          }
          catch(e){
            console.error(e);
          }
        }
        this.setSavingsDataInLocalStorage();
        this.$router.push({name: 'reportSummary'});
      }
    },
    setSavingsDataInLocalStorage(){
      const savingsData = {
        name: this.name,
        billAmount: this.billAmount,
        mobileNum: this.mobileNum,
        emailId: this.emailId,
        leadId: this.leadId,
        address: this.address,
        leadAlreadyExistsInDB: this.leadAlreadyExistsInDB,
      }
      let componentJSON = localStorage.getItem('componentData') ? JSON.parse(localStorage.getItem('componentData')) : defaultComponentsData();
      componentJSON.savingsData = savingsData;
      localStorage.setItem('componentData',JSON.stringify(componentJSON));
    },
  }
}
</script>

<style  scoped>
@font-face {
  font-family: "SegoeUI";
  src: url(/fonts/SegoeUI.ttf);
}

@media (max-width: 1100px) {

    
  .containerCS {
    /* display: none; */
    position: fixed;
    z-index: 100;
    bottom: 0px;
    width: 100%;
    padding: 24px 16px;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    background-color: #fff;
  }
}

  .inputLabelCS {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.38;
    margin-top: -4px;
    margin-bottom: 16px;
    text-align: center;
    font-family: "SegoeUI";
  }
  .containerCS :deep() .el-input__wrapper{
       height: 48px;
    width: 100%;
    font-size: 16px;
    color: #222;
    padding: 16px;
    box-sizing: border-box;
    outline: none;
    border: 1px solid #999;
    border-radius: 4px;
    background-color: #fff;
    margin-bottom: 14px;
    font-family: "SegoeUI";
  }

  .containerCS :deep() .el-input__inner::placeholder {
    color:#999;
    font-size: 16px;
    font-family: "SegoeUI";
  }

  .inputTag,.el-input__wrapper {
    height: 48px;
    width: 100%;
    font-size: 16px;
    color: #222;
    padding: 16px;
    box-sizing: border-box;
    outline: none;
    border: 1px solid #999;
    border-radius: 4px;
    background-color: #fff;
    margin-bottom: 14px;
    font-family: "SegoeUI";
  }

  .rupee {
    position: relative;
  }

  .billError {
    color: rgb(214, 12, 12);
    font-size: 13px;
    margin-top: -10px;
    margin-bottom: 8px;
  }

  .rupeeIcon {
    position: absolute;
    top: 16px;
    left: 16px;
  }

  .spaceLeft {
    padding-left: 32px;
  }

  .BtnMDCS {
    font-size: 16px;
    font-weight: 600;
    width: 100%;
    height: 48px;
    background-color:var(--bgColor);
  }
  
  .BtnMDCS:hover {
    background-color:var(--bgColor);
  }

  .BtnMDCS.is-disabled, .BtnMDCS.is-disabled:focus, .BtnMDCS.is-disabled:hover {
    color: #ccc;
    background-image: linear-gradient(to bottom, #f5f7fa, #e8edf2);
    border: 1px solid #ccc;
  }
/* } */
</style>

